<template>
  <UdmGenerator />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
